/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_Faq_Q4Inputs */

const en_guide_json_vs_yaml_xml_faq_q4 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can YAML do everything JSON can?`)
};

const ko_guide_json_vs_yaml_xml_faq_q4 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML은 JSON이 하는 모든 것을 할 수 있나요?`)
};

const ja_guide_json_vs_yaml_xml_faq_q4 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YAML は JSON にできることをすべてできますか?`)
};

/**
* | output |
* | --- |
* | "Can YAML do everything JSON can?" |
*
* @param {Guide_Json_Vs_Yaml_Xml_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_faq_q4 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_faq_q4(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_faq_q4(inputs)
	return ja_guide_json_vs_yaml_xml_faq_q4(inputs)
});